import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import {
    AppBar,
    Box,
    Breadcrumbs,
    Button,
    FormControl,
    Grid,
    IconButton,
    InputLabel,
    Link,
    MenuItem,
    Paper,
    Select,
    Tab,
    Tabs,
    TextField,
    Toolbar,
    Typography
} from "@mui/material";
import { withStyles } from "@mui/styles";
import axios from "axios";
import * as React from "react";
import { Link as RouterLink, Redirect } from "react-router-dom";
import { LoadingWrapper } from "../../../components/LoadingWrapper";
import { Config } from "../../../config/config";
import { getGlobalVar, Helpers } from "../../../utils/helpers";
import { PopupMessage } from "../../../utils/message";
import { UnitItem } from "./unit";
import { Wave } from "./wave";

interface MapEditorState {
    redirect: boolean;
    savingData: boolean;
    mapId: number;
    missionType: string;
    isLoaded: boolean;

    mapSettings: MapSettings;

    currentWaveTab: number;
    items: any[];
    units: Units;
    currentUnit: {
        id: number;
        level: number;
        amount: number;
    };
    rewards: any[];
}

export interface Units {
    heroes: any[];
    artillery: any[];
    followers: any[];
}

interface MapSettings {
    name?: null | string;
    description?: null | string;
    type: string;
    money: number;
    elixir: number;
    power: number;
    timeLimit: number;
    waves: MissionWave[];
}

interface MissionWave {
    id: number;
    delay: number;
    units: WaveUnit[];
}

interface WaveUnit {
    id: null | number;
    amount: number;
    level: number;
    position: number;
}

class DefenseEditorWrapped extends React.Component<{ activeUser: any; match: any; classes: any }, MapEditorState> {
    saving = false;
    waves: MissionWave[] = [];

    constructor(props) {
        super(props);

        this.state = {
            redirect: false,
            savingData: false,
            mapId: props.match.params.mapId,
            missionType: "defense",
            isLoaded: false,
            mapSettings: {
                name: null,
                description: null,
                type: "campaign",
                money: 0,
                elixir: 0,
                power: 0,
                timeLimit: 0,
                waves: [
                    {
                        id: 1,
                        delay: 15,
                        units: this.generateUnitPositions(),
                    },
                ],
            },
            currentUnit: {
                id: 0,
                level: 1,
                amount: 1,
            },
            currentWaveTab: 0,
            items: [],
            units: {
                heroes: [],
                artillery: [],
                followers: [],
            },
            rewards: [],
        };
    }

    async componentDidMount() {
        await this.fetchUnitConfig();
        await this.fetchMapData();
    }

    fetchUnitConfig = async () => {
        const result = await axios.get(`${Config.getInstance.apiUrl}/api/units`, {
            headers: {
                Authorization: Helpers.getSessionId(),
            },
            params: {
                bundleId: localStorage.getItem("currentBundleId") || "base",
            },
        });

        this.setState({
            units: {
                followers: result.data.data.followers.map(unit => {
                    unit.name = Helpers.getLocalizationName(unit.name);

                    return unit;
                }),

                artillery: result.data.data.artillery.map(unit => {
                    unit.name = Helpers.getLocalizationName(unit.name);

                    return unit;
                }),

                heroes: result.data.data.heroes.map(unit => {
                    unit.name = Helpers.getLocalizationName(unit.name);

                    return unit;
                }),
            },
        });
    };

    fetchMapData = async () => {
        try {
            const mapUrl = `${Config.getInstance.apiUrl}/api/bundle/singleplayer/${this.props.match.params.bundleId}/${this.state.missionType}/${this.state.mapId}`;
            const response = await axios.get(mapUrl, {
                headers: {
                    Authorization: Helpers.getSessionId(),
                },
            });

            if (response.status !== 200 || response.data.status === false) {
                return this.setState({isLoaded: true});
            }

            const mapData = response.data.data;

            let waves = mapData.waves;

            if (!waves || !Array.isArray(waves)) {
                waves = this.state.mapSettings.waves;
            }

            mapData.waves = waves.map(wave => {
                const units = this.generateUnitPositions().map(unit => {
                    const waveUnit = wave.units.find(_unit => _unit.position === unit.position);

                    if (!waveUnit) {
                        return unit;
                    }

                    return waveUnit;
                });

                return {
                    ...wave,
                    units,
                };
            });

            this.waves = JSON.parse(JSON.stringify(mapData.waves));

            this.setState({
                mapSettings: {
                    ...this.state.mapSettings,
                    name: mapData.name,
                    description: mapData.description,
                    type: mapData.type || "campaign",
                    money: mapData.honey,
                    elixir: mapData.elixir,
                    power: mapData.power,
                    timeLimit: mapData.timeLimit || 0,
                    waves: mapData.waves,
                },
                rewards: mapData.rewards && Array.isArray(mapData.rewards) ? mapData.rewards : [],
                isLoaded: true,
            });

        } catch (error) {
            console.error(error);

            PopupMessage.error("Couldn't load map data");

            this.setState({
                isLoaded: true,
            });
        }
    };

    handleWaveTabChange = (_event: any, newValue: any) => {
        this.setState(state => {
            state.currentWaveTab = newValue;
            state.mapSettings.waves = JSON.parse(JSON.stringify(this.waves));

            return state;
        });
    };

    saveUnit = (waveId: number, unit: UnitItem) => {
        const waveIndex = this.waves.findIndex(wave => wave.id === waveId);

        if (waveIndex < 0) {
            return;
        }

        const waveUnitIndex = this.waves[waveIndex].units.findIndex(_waveUnit => _waveUnit.position === unit.position);

        if (waveUnitIndex < 0) {
            return;
        }

        this.waves[waveIndex].units[waveUnitIndex].id = unit.id;
        this.waves[waveIndex].units[waveUnitIndex].level = unit.level;
        this.waves[waveIndex].units[waveUnitIndex].amount = unit.amount;
    };

    removeWaveUnit = (waveId: number, unit: UnitItem) => {
        const waveIndex = this.waves.findIndex(wave => wave.id === waveId);

        if (waveIndex < 0) {
            return;
        }

        const waveUnitIndex = this.waves[waveIndex].units.findIndex(_waveUnit => _waveUnit.position === unit.position);

        if (waveUnitIndex < 0) {
            return;
        }

        this.waves[waveIndex].units[waveUnitIndex].id = null;
    };

    coordinatesFromPosition = (position: number) => ({
        x: Math.round(position % 46),
        y: Math.round(position / 46),
    });

    positionFromCoordinates = (x: number, y: number) => x + 46 * y;

    generateUnitPositions() {
        const width = 46;
        const height = 46;
        const padding = 3;

        const paddingPositions: any[] = [];
        const usedPositions = [];

        for (let y = 0; y < (height + 1); y++) {
            if (y >= padding && y < height - padding) {
                continue;
            }

            for (let x = 0; x < width; x++) {
                const position = this.positionFromCoordinates(x, y);

                if (usedPositions.includes(position)) {
                    continue;
                } else {
                    usedPositions.push(position);
                }

                paddingPositions.push({
                    position,
                    id: null,
                    level: 1,
                    amount: 1,
                });
            }
        }

        for (let x = 0; x < (width + 1); x++) {
            if (x >= padding && x < width - padding) {
                continue;
            }

            for (let y = 0; y < height; y++) {
                const position = this.positionFromCoordinates(x, y);

                if (usedPositions.includes(position)) {
                    continue;
                } else {
                    usedPositions.push(position);
                }

                paddingPositions.push({
                    position,
                    id: null,
                    level: 1,
                    amount: 1,
                });
            }
        }

        return paddingPositions.sort((a, b) => a.position - b.position);
    }

    changeSetting = (key: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
        const tempSettings = {...this.state.mapSettings};

        switch (key) {
            case "money":
            case "elixir":
            case "power":
            case "timeLimit":
                tempSettings[key] = +event.target.value;
                break;
            default:
                tempSettings[key] = event.target.value;
        }

        this.setState({mapSettings: tempSettings});
    };

    addReward = () => {
        this.setState({
            rewards: [...this.state.rewards, {
                itemId: "",
                amount: 0,
            }],
        });
    };

    rewardChange = (e, index) => {
        const tempRewards = [...this.state.rewards];
        const isNumericString = /^\d+$/.test(e.target.value as any);
        const itemId = isNumericString ? +e.target.value : e.target.value as number;

        tempRewards[index].itemId = itemId as any;

        if (this.isAttachment(itemId)) {
            tempRewards[index].level = 1;
        } else {
            delete tempRewards[index].level;
        }

        this.setState({rewards: tempRewards});
    };

    changeAmount = (e, index) => {
        const tempRewards = [...this.state.rewards];
        tempRewards[index].amount = parseInt(e.target.value, 10);
        this.setState({rewards: tempRewards});
    };

    changeLevel = (e, index) => {
        const tempRewards = [...this.state.rewards];
        tempRewards[index].level = parseInt(e.target.value, 10);
        this.setState({rewards: tempRewards});
    };

    removeReward = (index) => {
        const tempRewards = [...this.state.rewards];
        tempRewards.splice(index, 1);
        this.setState({rewards: tempRewards});
    };

    getTypeByItemId = (itemId: number) => {
        const itemObject = getGlobalVar("ITEMS").find(item => item.id === itemId);
        return itemObject ? itemObject.type : null;
    };

    changeType = (e) => {
        this.setState((state) => {
            state.mapSettings.type = e.target.value;

            return state;
        });
    };

    isAttachment = (itemId: number) => {
        const itemType = this.getTypeByItemId(itemId);

        if (!itemType) {
            return false;
        }

        switch (itemType) {
            case "weapon":
            case "torso":
            case "legs":
                return true;
            default:
                return false;
        }
    };

    addWave = () => {
        this.waves.push({
            id: this.waves.length + 1,
            delay: 15,
            units: this.generateUnitPositions(),
        });

        this.setState(state => {
            state.mapSettings.waves = JSON.parse(JSON.stringify(this.waves));

            return state;
        });
    };

    updateWave = (id: number, delay: number) => {
        const index = this.waves.findIndex(wave => wave.id === id);

        if (index < 0) {
            return;
        }

        this.waves[index].delay = delay;
    };

    removeWave = (id) => {
        if (!confirm("Are you sure you want to do that?")) {
            return;
        }

        if (this.waves.length > 1) {
            this.waves.splice(this.waves.findIndex(wave => wave.id === id), 1);
        }

        this.waves = this.waves.map((wave, _index) => ({
            ...wave,
            id: _index + 1,
        }));

        this.setState(state => {
            state.currentWaveTab = 0;

            state.mapSettings.waves = JSON.parse(JSON.stringify(this.waves));

            return state;
        });
    };

    prepareJsonForExport = async () => {
        if (this.saving) {
            return;
        }

        this.saving = true;

        this.setState({savingData: true});

        const jsonToExport = {
            name: this.state.mapSettings.name,
            description: this.state.mapSettings.description,
            type: this.state.mapSettings.type || "campaign",
            honey: this.state.mapSettings.money,
            elixir: this.state.mapSettings.elixir,
            power: this.state.mapSettings.power,
            timeLimit: this.state.mapSettings.timeLimit,
            waves: this.waves.map(item => ({
                id: item.id,
                delay: item.delay,
                units: item.units.filter(unit => unit.id !== null),
            })),
            rewards: this.state.rewards,
        };

        // Save map data
        try {
            const result = await axios.post(`${Config.getInstance.apiUrl}/singleplayer/save`, {
                data: jsonToExport,
                mapId: this.state.mapId,
                bundleId: this.props.match.params.bundleId,
                missionType: this.state.missionType,
            }, {
                headers: {
                    Authorization: Helpers.getSessionId(),
                },
            });

            // Otherwise load and show a list with applications
            return this.setState({
                savingData: false,
                redirect: true,
            });
        } catch (e) {
            this.setState({savingData: false}, () => {
                PopupMessage.error("Couldn't save map data");
            });
        }

        this.saving = false;
    };

    render() {
        const {classes} = this.props;
        // If we need a redirect to main bundle page
        if (this.state.redirect) {
            return <Redirect to={`/bundle/missions/${this.state.missionType}`}/>;
        }

        const TabPanel = (props: any) => {
            const {children, value, index, ...other} = props;

            return (
                <div
                    role="tabpanel"
                    hidden={value !== index}
                    id={`simple-tabpanel-${index}`}
                    aria-labelledby={`simple-tab-${index}`}
                    {...other}
                >
                    {value === index && (
                        <Box p={3}>
                            {children}
                        </Box>
                    )}
                </div>
            );
        };

        const formItems = () => (this.state.rewards || []).map((reward, index) => (
            <div className={classes.formRow} style={{marginTop: 15}} key={`reward_${index}`}>
                <div style={{width: 200, display: "inline-block"}}>
                    <FormControl style={{width: "100%"}}>
                        <InputLabel htmlFor="age-simple">Item</InputLabel>

                        <Select
                            value={reward.itemId}
                            style={{width: "100%"}}
                            onChange={event => this.rewardChange(event, index)}
                            native={true}
                            inputProps={{
                                name: "Item",
                                id: "item-id-select",
                            }}
                        >
                            {getGlobalVar("ITEMS").map(item => (
                                <option value={item.id} key={item.id}>
                                    [{item.id}] {Helpers.getLocalizationName(item.name)}
                                </option>
                            ))}
                        </Select>
                    </FormControl>
                </div>

                <div style={{width: 100, display: "inline-block", marginLeft: 10}}>
                    <TextField
                        id="reward-amount"
                        label="Amount"
                        value={reward.amount}
                        onChange={event => this.changeAmount(event, index)}
                        type="number"
                        margin="normal"
                        style={{margin: 0}}
                    />
                </div>

                <div style={{width: 100, display: "inline-block", marginLeft: 10}}>
                    {this.isAttachment(+reward.itemId) &&
                    <TextField
                        id="reward-amount"
                        label="Level"
                        value={reward.level}
                        onChange={event => this.changeLevel(event, index)}
                        type="number"
                        margin="normal"
                        style={{margin: 0}}
                    />
                    }
                </div>

                <div style={{width: 25, display: "inline-block", marginLeft: 10, height: 48}}>
                    <IconButton aria-label="Delete" onClick={() => this.removeReward(index)} size="small"
                                style={{marginTop: 18}}>
                        <DeleteIcon fontSize="inherit"/>
                    </IconButton>
                </div>
            </div>
        ));

        const waves = this.state.mapSettings.waves;

        return <div className="contentPadding">
            <Paper className="root" elevation={0}>
                <Grid container>
                    <Grid item xs={12} style={{padding: "15px 22px 15px 22px"}}>
                        <div className={classes.title}>
                            <Breadcrumbs
                                separator={<NavigateNextIcon fontSize="small"/>}
                                aria-label="breadcrumb"
                                className="bundle-breadcrumbs"
                            >
                                <Link to={`/bundle/missions/${this.state.missionType}/`} component={RouterLink as any}>
                                    All maps
                                </Link>
                                <Typography color="textPrimary">
                                    Edit <strong>{this.state.mapSettings.name}</strong>
                                </Typography>
                            </Breadcrumbs>
                        </div>
                    </Grid>
                    <Grid item xs={12}>
                        <LoadingWrapper loading={!this.state.isLoaded}>
                            <AppBar position="static">
                                <Toolbar className={classes.toolbar}>
                                    <Tabs
                                        value={this.state.currentWaveTab}
                                        onChange={this.handleWaveTabChange}
                                        variant="scrollable"
                                        scrollButtons="auto"
                                    >
                                        {waves.map(wave =>
                                            <Tab label={"Wave " + wave.id} key={"Wave " + wave.id}/>,
                                        )}
                                    </Tabs>

                                    <IconButton onClick={this.addWave} edge="end" className={classes.menuButton}>
                                        <AddIcon/>
                                    </IconButton>
                                </Toolbar>
                            </AppBar>

                            {waves.map((wave, index) =>
                                <TabPanel value={this.state.currentWaveTab} index={index} key={"map-" + index}>
                                    <Wave wave={wave} waveAmount={waves.length} units={this.state.units}
                                          onRemoveWave={this.removeWave} onSaveUnit={this.saveUnit}
                                          onRemoveUnit={this.removeWaveUnit} onUpdateWaveDelay={this.updateWave}/>
                                </TabPanel>,
                            )}

                            <div className={classes.formWrapper}>
                                {this.state.isLoaded && <div>
                                    <h3>Settings</h3>

                                    <div className={classes.formRow}>
                                        <TextField
                                            label="Name"
                                            value={this.state.mapSettings.name || ""}
                                            margin="normal"
                                            onChange={this.changeSetting("name")}
                                            style={{width: "100%"}}
                                        />
                                    </div>

                                    <div className={classes.formRow}>
                                        <TextField
                                            label="Description"
                                            value={this.state.mapSettings.description || ""}
                                            margin="normal"
                                            multiline
                                            rows="2"
                                            onChange={this.changeSetting("description")}
                                            style={{width: "100%"}}
                                        />
                                    </div>

                                    <div className={classes.formRow}>
                                        <InputLabel>Type</InputLabel>

                                        <Select value={this.state.mapSettings.type}
                                                onChange={(e) => this.changeType(e)}>
                                            <MenuItem value="campaign">Campaign</MenuItem>
                                            <MenuItem value="event">Event</MenuItem>
                                            <MenuItem value="custom">Custom</MenuItem>
                                        </Select>
                                    </div>

                                    <div className={classes.formRow}>
                                        <TextField
                                            label="Time limit"
                                            value={this.state.mapSettings.timeLimit || 0}
                                            margin="normal"
                                            helperText="Total mission time in seconds"
                                            onChange={this.changeSetting("timeLimit")}
                                            type="tel"
                                            inputProps={{
                                                pattern: "[0-9]*",
                                            }}
                                        />
                                    </div>

                                    <h3 style={{marginTop: 15}}>Rewards</h3>

                                    <div className={classes.formRow}>
                                        <Button disableElevation onClick={this.addReward} variant="contained">
                                            <AddIcon/> Add reward
                                        </Button>
                                    </div>

                                    <div className={classes.formRow}>
                                        {formItems()}
                                    </div>

                                    <div className={classes.formRow} style={{marginTop: 45}}>
                                        <Button disableElevation onClick={this.prepareJsonForExport} disabled={this.state.savingData}
                                                variant="contained" color="primary">
                                            {(this.state.savingData) ? "Saving..." : "Save map"}
                                        </Button>
                                    </div>
                                </div>}
                            </div>
                        </LoadingWrapper>
                    </Grid>
                </Grid>
            </Paper>
        </div>;
    }
}

const styles: any = theme => ({
    title: {
        flex: "0 0 auto",
        float: "left",
    },
    actions: {
        color: theme.palette.text.secondary,
        float: "right",
    },
    formWrapper: {
        display: "block",
        float: "left",
        width: "100%",
        padding: "15px 22px 15px 22px",
    },
    formRow: {
        display: "block",
    },
});

export const DefenseMapEditor = withStyles(styles)(DefenseEditorWrapped);
